export default {
  // 'this' - $store
  byActionType: {
  },
  // 'this' - $store
  byEventType: {

  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
  },
  eventClasses: {
  }
}
